module.exports = __webpack_public_path__ + "static/media/phone@2x.dccca2a6.png";